export { default } from "./LockUser";



// WEBPACK FOOTER //
// ./src/mutations/LockUser/index.ts